document.addEventListener("DOMContentLoaded", function () {
    const thumbnails = document.querySelectorAll('.gkd-thumbnail');
    const mainTrack = document.querySelector('.gkd-main-media-track');
    const slides = document.querySelectorAll('.gkd-slide');
    const prevBtn = document.querySelector('.gkd-prev');
    const nextBtn = document.querySelector('.gkd-next');
    const thumbContainer = document.querySelector('.gkd-thumbnails');
    const navUp = document.querySelector('.gkd-nav-up');
    const navDown = document.querySelector('.gkd-nav-down');
    const navLeft = document.querySelector('.gkd-nav-left');
    let currentIndex = 0;
    let startX = 0;
    let endX = 0;

    function updateSlider(index) {
        mainTrack.style.transform = `translateX(-${index * 100}%)`;
        thumbnails.forEach(thumb => thumb.classList.remove('active'));
        thumbnails[index].classList.add('active');
    }

    thumbnails.forEach((thumbnail, index) => {
        thumbnail.addEventListener('click', function () {
            currentIndex = index;
            updateSlider(index);
        });
    });

    prevBtn.addEventListener('click', function () {
        if (currentIndex > 0) {
            currentIndex--;
            updateSlider(currentIndex);
        }
    });

    nextBtn.addEventListener('click', function () {
        if (currentIndex < slides.length - 1) {
            currentIndex++;
            updateSlider(currentIndex);
        }
    });

    // Thumbnail Scroll Navigation
    navUp.addEventListener('click', function () {
        thumbContainer.scrollBy({ top: -80, behavior: 'smooth' });
    });

    navDown.addEventListener('click', function () {
        thumbContainer.scrollBy({ top: 80, behavior: 'smooth' });
    });

    navLeft.addEventListener('click', function () {
        thumbContainer.scrollTo({ top: 0, behavior: 'smooth' });
    });

    // **Touch Swipe Event for Mobile**
    mainTrack.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
    });

    mainTrack.addEventListener('touchmove', (e) => {
        endX = e.touches[0].clientX;
    });

    mainTrack.addEventListener('touchend', () => {
        if (startX - endX > 50) {
            // Swiped left
            if (currentIndex < slides.length - 1) {
                currentIndex++;
                updateSlider(currentIndex);
            }
        } else if (endX - startX > 50) {
            // Swiped right
            if (currentIndex > 0) {
                currentIndex--;
                updateSlider(currentIndex);
            }
        }
    });
});


document.addEventListener("DOMContentLoaded", function () {
    const bundleWrappers = document.querySelectorAll('.gkd-bundle-wrapper');
    const quantitySelector = document.querySelector('.gkd-quantity-selector');
    const qtyInput = document.querySelector('.gkd-qty-input');
    const totalPriceElement = document.getElementById('gkd-total-price');
    const addToCartBtn = document.querySelector('.gkd-add-to-cart');

    function updateTotalPrice() {
        let selectedBundle = document.querySelector('.gkd-bundle-option input:checked');
        let pricePerItem = parseFloat(selectedBundle.getAttribute('data-price'));
        let quantity = parseInt(selectedBundle.value); // Get the bundle quantity
        if (selectedBundle.value === "4") {
            quantity = parseInt(qtyInput.value); // Use the quantity input for 4+ Mushis
        }
        let totalPrice = pricePerItem * quantity;
        totalPriceElement.textContent = totalPrice.toFixed(2);
    }

    bundleWrappers.forEach(wrapper => {
        wrapper.addEventListener('click', function (event) {
            if (event.target.closest('.gkd-quantity-selector')) return;

            const input = this.querySelector('.gkd-bundle-option input');
            if (input) {
                input.checked = true;

                if (input.value === "4") {
                    quantitySelector.style.display = 'flex';
                    if (parseInt(qtyInput.value) < 4) {
                        qtyInput.value = 4;
                    }
                } else {
                    quantitySelector.style.display = 'none';
                    qtyInput.value = input.value; // Set quantity for 1, 2, or 3 Mushis
                }

                updateTotalPrice();
            }
        });
    });

    document.querySelector('.gkd-qty-plus').addEventListener('click', function (event) {
        event.stopPropagation();
        qtyInput.value = parseInt(qtyInput.value) + 1;
        updateTotalPrice();
    });

    document.querySelector('.gkd-qty-minus').addEventListener('click', function (event) {
        event.stopPropagation();
        if (qtyInput.value > 4) {
            qtyInput.value = parseInt(qtyInput.value) - 1;
            updateTotalPrice();
        }
    });

    qtyInput.addEventListener('input', function (event) {
        event.stopPropagation();
        if (parseInt(qtyInput.value) < 4) {
            qtyInput.value = 4;
        }
        updateTotalPrice();
    });

    addToCartBtn.addEventListener('click', function () {
        let selectedBundle = document.querySelector('.gkd-bundle-option input:checked');
        let quantity = parseInt(selectedBundle.value); // Get quantity from selected bundle
        if (selectedBundle.value === "4") {
            quantity = parseInt(qtyInput.value); // Use the quantity input for 4+ Mushis
        }

        fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ 
                id: 44656791027893, 
                quantity: quantity 
            })
        })
        .then(response => response.json())
        .then(data => {
            window.location.href = "/checkout"
        })
        .catch(error => console.error('Error adding to cart:', error));
    });

    updateTotalPrice(); // Initialize total price on page load
});
